import React, { Component } from 'react';

import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import DateFormat from '../common/dateFormat/DateFormat';

class ProducaoCargaForm extends Component {

	componentDidMount() {
		this.focarPrimeiroLotePendente();
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.carga.status_producao !== 'EM_PRODUCAO'
			&& this.props.carga.status_producao === 'EM_PRODUCAO'
		) {
			this.focarPrimeiroLotePendente();
		}
	}

	focarPrimeiroLotePendente() {
		if (this.props.carga.status_producao !== 'EM_PRODUCAO') return;

		setTimeout(() => {
			const campos = Array.from(document.querySelectorAll('[data-lote="true"]'));
			const campo = campos.find(item => !String(item.value || '').trim()) || campos[0];
			if (campo) campo.focus();
		}, 100);
	}

	resumoLotes() {
		let total = 0;
		let preenchidos = 0;

		(this.props.carga.producoes || []).forEach(producao => {
			(producao.itens || []).forEach(batida => {
				total++;
				if (String(batida.lote_producao || '').trim()) preenchidos++;
			});
		});

		return { total, preenchidos, completo: total > 0 && total === preenchidos };
	}

	atualizarLote(idProducao, indiceBatida, lote) {
		const carga = this.props.carga;

		this.props.setCarga({
			...carga,
			producoes: (carga.producoes || []).map(producao => (
				String(producao.id_producao) !== String(idProducao) ? producao : {
					...producao,
					itens: (producao.itens || []).map((batida, indice) => (
						indice !== indiceBatida ? batida : {
							...batida,
							lote_producao: lote,
							lote_alterado: true
						}
					))
				}
			))
		});
	}

	montarLote(producao, batida, indiceBatida) {
		return {
			id_producao: producao.id_producao,
			indice_batida: indiceBatida,
			numero_batida: batida.lote || indiceBatida + 1,
			lote: String(batida.lote_producao || '').trim()
		};
	}

	montarTodosLotes() {
		const lotes = [];
		(this.props.carga.producoes || []).forEach(producao => {
			(producao.itens || []).forEach((batida, indiceBatida) => {
				if (batida.lote_alterado) {
					lotes.push(this.montarLote(producao, batida, indiceBatida));
				}
			});
		});
		return lotes;
	}

	salvarLote(producao, batida, indiceBatida) {
		this.props.salvarLotes(
			this.props.carga.id,
			[this.montarLote(producao, batida, indiceBatida)],
			true
		);
	}

	avancar(event) {
		if (event.key !== 'Enter') return;
		event.preventDefault();
		event.currentTarget.blur();
		const campos = Array.from(document.querySelectorAll('[data-lote="true"]'));
		const proximo = campos[campos.indexOf(event.currentTarget) + 1];
		if (proximo) {
			proximo.focus();
			proximo.select();
		}
	}

	lerOutraCarga() {
		if (this.props.carga.status_producao !== 'EM_PRODUCAO') {
			this.props.limparCarga();
			return;
		}

		const lotes = this.montarTodosLotes();

		if (!lotes.length) {
			this.props.limparCarga();
			return;
		}

		this.props.salvarLotes(
			this.props.carga.id,
			lotes,
			true
		).then(sucesso => sucesso && this.props.limparCarga());
	}

	cancelarInicio() {
		const motivo = window.prompt('Informe o motivo do cancelamento do início:');
		if (motivo !== null) this.props.cancelarInicioProducaoCarga(this.props.carga.id, motivo);
	}

	reabrir() {
		const motivo = window.prompt('Informe o motivo da reabertura:');
		if (motivo !== null) this.props.reabrirProducaoCarga(this.props.carga.id, motivo);
	}

	finalizar() {
		if (window.confirm('Confirma a finalização da produção de toda a carga?')) {
			this.props.finalizarProducaoCarga(this.props.carga.id).then(sucesso => {
				if (sucesso) {
					this.props.limparCarga();
				}
			});
		}
	}

	status() {
		if (this.props.carga.status_producao === 'EM_PRODUCAO') return 'Em produção';
		if (this.props.carga.status_producao === 'FINALIZADA') return 'Finalizada';
		return 'Não iniciada';
	}

	renderProducoes() {
		const carga = this.props.carga;
		const editavel = carga.status_producao === 'EM_PRODUCAO' && this.props.podeAlterar;

		return (carga.producoes || []).map((producao, indiceProducao) => (
			<ContentCard key={producao.id_producao} style={{ marginTop: 10 }}>
				<ContentCardHeader>
					<h3 className='card-title' style={{ fontWeight: 'bold' }}>
						{indiceProducao + 1}. Produção {producao.id_producao} - {producao.nome_parceiro} - {producao.nome_racao}
					</h3>
				</ContentCardHeader>
				<ContentCardBody>
					{(producao.itens || []).map((batida, indiceBatida) => (
						<div key={indiceBatida} style={{
							marginBottom: 18,
							border: '2px solid #adb5bd',
							borderLeft: '6px solid #007bff',
							borderRadius: 4,
							overflow: 'hidden',
							boxShadow: '0 1px 3px rgba(0, 0, 0, 0.10)'
						}}>
							<div style={{
								backgroundColor: '#e9ecef',
								borderBottom: '2px solid #adb5bd',
								padding: '9px 12px',
								fontSize: 16,
								fontWeight: 'bold',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								gap: 15
							}}>
								<span>Batida {batida.lote || indiceBatida + 1}</span>
								<div style={{ display: 'flex', alignItems: 'center', gap: 8, width: 360 }}>
									<label style={{ marginBottom: 0, whiteSpace: 'nowrap' }}>Lote *</label>
									<input
										data-lote='true'
										type='text'
										className='form-control'
										value={batida.lote_producao || ''}
										readOnly={!editavel}
										onChange={event => this.atualizarLote(
											producao.id_producao, indiceBatida, event.target.value
										)}
										onBlur={() => editavel && this.salvarLote(producao, batida, indiceBatida)}
										onKeyDown={event => this.avancar(event)} />
								</div>
							</div>
							<div className='table-responsive'>
								<table className='table table-bordered table-sm' style={{ marginBottom: 0 }}>
									<thead>
										<tr>
											<th>Matéria-prima</th>
											<th style={{ width: 140, textAlign: 'right' }}>Quantidade</th>
										</tr>
									</thead>
									<tbody>
										{(batida.materias_primas || []).map(materiaPrima => (
											<tr key={materiaPrima.id_materia_prima}>
												<td>{materiaPrima.nome_materia_prima}</td>
												<td style={{ textAlign: 'right' }}>
													{materiaPrima.quantidade} {materiaPrima.sigla_unidade_medida}
												</td>
										</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					))}
				</ContentCardBody>
			</ContentCard>
		));
	}

	render() {
		const carga = this.props.carga;
		const lotes = this.resumoLotes();

		return (
			<div>
				<div style={{
					position: 'sticky',
					top: 0,
					zIndex: 1020,
					backgroundColor: '#f4f6f9',
					paddingBottom: 10
				}}>
					<ContentCard style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)' }}>
					<ContentCardHeader>
						<h3 className='card-title' style={{ fontWeight: 'bold' }}>
							Produção da Carga {carga.id} - {this.status()}
						</h3>
					</ContentCardHeader>
					<ContentCardBody>
						<div className='row'>
							<div className='col-md-2'><strong>Código</strong><br />{carga.codigo_barras}</div>
							<div className='col-md-2'><strong>Data</strong><br />{DateFormat.formatarDataSqlParaTela(carga.data_agendamento)}</div>
							<div className='col-md-2'><strong>Veículo</strong><br />{carga.placa_veiculo || '-'}</div>
							<div className='col-md-3'><strong>Motorista</strong><br />{carga.nome_motorista || '-'}</div>
							<div className='col-md-3'><strong>Lotes</strong><br />{lotes.preenchidos} de {lotes.total}</div>
						</div>

						{carga.datahora_inicio_producao &&
						<div style={{ marginTop: 10 }}>
							<strong>Início:</strong> {DateFormat.formatarDataHoraSqlParaTela(carga.datahora_inicio_producao)} - {carga.nome_usuario_inicio_producao}
						</div>}

						<div style={{ marginTop: 15 }}>
							{carga.status_producao === 'NAO_INICIADA' && this.props.podeIniciar &&
							<button type='button' className='btn btn-success btn-lg' onClick={() => this.props.iniciarProducaoCarga(carga.id)}>
								Iniciar Produção da Carga
							</button>}

							{carga.status_producao === 'NAO_INICIADA' &&
							<button type='button' className='btn btn-secondary btn-lg' style={{ marginLeft: 8 }} onClick={() => this.props.limparCarga()}>
								Voltar
							</button>}

							{carga.status_producao === 'EM_PRODUCAO' &&
							<button type='button' className='btn btn-secondary btn-lg' onClick={() => this.lerOutraCarga()}>
								Voltar
							</button>}

							{carga.status_producao === 'EM_PRODUCAO' && this.props.podeAlterar &&
							<button type='button' className='btn btn-primary btn-lg' style={{ marginLeft: 8 }}
								disabled={!lotes.completo || this.props.salvando}
								onClick={() => this.finalizar()}>
								Finalizar Produção da Carga
							</button>}

							{carga.status_producao === 'EM_PRODUCAO' && this.props.podeExcluir &&
							<button type='button' className='btn btn-danger btn-lg' style={{ marginLeft: 8 }} onClick={() => this.cancelarInicio()}>
								Cancelar Início
							</button>}

							{carga.status_producao === 'FINALIZADA' && this.props.podeExcluir &&
							<button type='button' className='btn btn-warning btn-lg' onClick={() => this.reabrir()}>
								Reabrir Produção da Carga
							</button>}

							{carga.status_producao === 'FINALIZADA' &&
							<button type='button' className='btn btn-secondary btn-lg' style={{ marginLeft: 8 }} onClick={() => this.props.limparCarga()}>
								Voltar
							</button>}
						</div>
					</ContentCardBody>
					</ContentCard>
				</div>

				{this.renderProducoes()}
			</div>
		);
	}
}

export default ProducaoCargaForm;
